import { createContext } from 'react';

export type TouchGesture = {
  pinchActive: boolean;
  pinchScale: number;
  lastPinchDistance: number;
};

export type TouchGestureContextType = {
  enableGestures: boolean;
  setEnableGestures: (enable: boolean) => void;
  gesture: TouchGesture;
  touchEnabled: boolean;
  isFormDialogOpen: boolean;
  setFormDialogOpen: (isOpen: boolean) => void;
};

export const TouchGestureContext = createContext<TouchGestureContextType>({
  enableGestures: true,
  setEnableGestures: () => {},
  gesture: { pinchActive: false, pinchScale: 1, lastPinchDistance: 0 },
  touchEnabled: false,
  isFormDialogOpen: false,
  setFormDialogOpen: () => {},
});
